import { HeroUIProvider } from '@heroui/system'
import { QueryProvider } from '@qse/api'
import { useCrossTabLogout } from '@qse/auth-ui'
import { SentryErrorBoundary, useSentryUser } from '@qse/sentry'
import { ModalComponent, ThemeProvider, Toaster } from '@qse/ui'
import { useGlobalFolderDeletionListener } from '@qse/utils'
import type { NavigateOptions } from 'react-router-dom'
import { useHref, useNavigate } from 'react-router-dom'

import { useAdminRealtime } from './hooks'

declare module '@react-types/shared' {
  interface RouterConfig {
    routerOptions: NavigateOptions
  }
}

function RealtimeProvider({ children }: { children: React.ReactNode }) {
  // Initialize WebSocket connection for admin app
  useAdminRealtime()

  // Listen for folder deletion events across all tabs
  useGlobalFolderDeletionListener()

  // Sync logout across browser tabs
  useCrossTabLogout()

  // Sync user context with Sentry
  useSentryUser()

  return <>{children}</>
}

export function Provider({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate()

  return (
    <SentryErrorBoundary>
      <HeroUIProvider navigate={navigate} useHref={useHref}>
        <ThemeProvider>
          <QueryProvider>
            <RealtimeProvider>
              {children}
              <ModalComponent />
              <Toaster />
            </RealtimeProvider>
          </QueryProvider>
        </ThemeProvider>
      </HeroUIProvider>
    </SentryErrorBoundary>
  )
}
